import { render, staticRenderFns } from "./PollEdit.vue?vue&type=template&id=24b3bdf0&"
import script from "./PollEdit.vue?vue&type=script&lang=js&"
export * from "./PollEdit.vue?vue&type=script&lang=js&"
import style0 from "./PollEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports